import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchQuestionaryList({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get(`/questionary?${formatParams(params)}`)
      .then((questionaries) => {
        commit('setData', questionaries);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};
